var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.199,
    height: 105,
    viewBox: "0 0 100.199 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e87f38;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "premium_user",
    transform: "translate(-285 -666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_people_24px",
    d: "M69.182,32.273A13.636,13.636,0,1,0,55.545,18.636,13.579,13.579,0,0,0,69.182,32.273Zm-36.364,0A13.636,13.636,0,1,0,19.182,18.636,13.579,13.579,0,0,0,32.818,32.273Zm0,9.091C22.227,41.364,1,46.682,1,57.273V68.636H64.636V57.273C64.636,46.682,43.409,41.364,32.818,41.364Zm36.364,0c-1.318,0-2.818.091-4.409.227,5.273,3.818,8.955,8.955,8.955,15.682V68.636H101V57.273C101,46.682,79.773,41.364,69.182,41.364Z",
    transform: "translate(284 661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_star_24px",
    className: "cls-1",
    d: "M17.63,25.867l9.659,5.83L24.726,20.709l8.534-7.393-11.238-.953L17.63,2,13.238,12.363,2,13.316l8.534,7.393L7.971,31.7Z",
    transform: "translate(283 734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_star_24px-2",
    "data-name": "ic_star_24px",
    className: "cls-1",
    d: "M17.63,25.867l9.659,5.83L24.726,20.709l8.534-7.393-11.238-.953L17.63,2,13.238,12.363,2,13.316l8.534,7.393L7.971,31.7Z",
    transform: "translate(316.939 739.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_star_24px-3",
    "data-name": "ic_star_24px",
    className: "cls-1",
    d: "M17.63,25.867l9.659,5.83L24.726,20.709l8.534-7.393-11.238-.953L17.63,2,13.238,12.363,2,13.316l8.534,7.393L7.971,31.7Z",
    transform: "translate(351.939 734)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumUser);
export default __webpack_public_path__ + "static/media/premium_user.a4936f145c1179367904d28e80f95ed8.svg";
export { ForwardRef as ReactComponent };